import { takeLatest, select, call, apply, put } from 'redux-saga/effects';
import * as types from '../constants/actionTypes';
import { logAPI } from "../api/andyliticsApi";
import { setMarketingEmailOptIn } from "../api/mybswBFFApi";

export default function* marketingEmailOptInSaga() {
    yield takeLatest(types.SET_MARKETING_EMAIL_OPT_IN, handleMarketingEmailOptIn, setMarketingEmailOptIn, 'MBHWeb.Saga.SetMarketingEmailOptIn');
}

function* handleMarketingEmailOptIn(apiCall, andyliticsLogName, action) {
    const domainData = yield select((state) => state.domain);
    const type = action.type;
    const start = new Date();
    const data = action.data;

    try {
        if (!action.success && !action.error) {
            let response = null;
            response = yield call(apiCall, domainData.t, data);

            if (andyliticsLogName) {
                logAPI(andyliticsLogName, start, null, "");
            }

            yield put({
                type: types.SET_MARKETING_EMAIL_OPT_IN_SUCCESS
            });
            yield put({
                type: types.UPDATE_SEEN_MARKETING_EMAIL_OPT_IN
            });
        }
    }

    catch (error) {
        if (andyliticsLogName) {
            logAPI(andyliticsLogName + '.Failure', start, null, error);
        }

        if (error !== null && error.status !== 401) {
            yield put({ type: types.SET_MARKETING_EMAIL_OPT_IN_FAILURE, error: error });
        }
    }
}